import { useLayoutEffect, useState, useCallback } from 'react';
import browser from '@openclassrooms/utils/browser';
export function checkIfOverflowed(clientWidth, scrollWidth) {
  return scrollWidth > clientWidth;
}
export default function useIsOverflowed(deps = []) {
  const [domElement, setDomElement] = useState(null);
  const [isOverflowed, setIsOverflowed] = useState(false);
  const checkIfElementOverflows = useCallback(() => {
    setIsOverflowed(checkIfOverflowed(domElement?.clientWidth, domElement?.scrollWidth));
  }, [domElement, ...deps]);
  useLayoutEffect(() => {
    checkIfElementOverflows();
    browser.window.addEventListener('resize', checkIfElementOverflows);
    return () => {
      browser.window.removeEventListener('resize', checkIfElementOverflows);
    };
  }, [checkIfElementOverflows]);
  return {
    isOverflowed,
    setDomElement
  };
}